module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue4.3c8d8368.jpg";